import React, { Fragment, useRef, useState } from "react";
import axios from "axios";
import LinkButton from "../../utils/LinkButton";
import Loader from "../Loading/loading";

import cursosimg from "../../static/images/cursos_default.png";
import useOnceEffect from "../../Hooks/useOnceEffect";

function CardGroups({ id, qty = 3 }) {
  const [indicators, setindicators] = useState([]);
  const [items, setitems] = useState([]);
  const [loading, setloading] = useState(true);
  const page = useRef(1)
  const groups = useRef([])
  const rol = useRef("user")

  useOnceEffect(() => {

    let role = localStorage.getItem("rol")

    switch(role) {
      case "institute":
        rol.current = "CentroFormacion"
        break;
      case "company":
        rol.current = "company"
        break;

      default:
        break
    }
    Carouselinner();
  });

  function getMoreItems() {
    axios.get(`groups/random?page=${page.current}`).then((result) => {
      if(result.data.length === 0){
        return
      }

      page.current = page.current + 1;
      groups.current = [...groups.current, ...result.data]
      LoadData(groups.current)
    });
  }

  function Carouselinner() {
    axios.get("groups/random").then((result) => {
      groups.current = result.data
      LoadData(groups.current);
    });
  }

  function LoadData(data) {
    let indice = 0;
    let step = parseInt(qty);

    let arrItems = [];

    data = [...data, {isLast: true}];

    for (let index = 0; index <= data.length - 1; index) {
      let arr = data.slice(index, step);


      let carItem = (
        <div
          key={Math.floor(Math.random() * 1000)}
          data-bs-interval="1000000"
          className={index === 0 ? "carousel-item active" : "carousel-item"}
        >
          {arr.map((item) => {

            if(item?.isLast) {
              return (
                <div key={item.id} className="card-item">
                  <div className="card-container text-center d-flex align-items-center" style={{height: "100%"}}>
                    <button
                      className="btn-deg"
                      onClick={getMoreItems}
                    >
                      Ver Más
                    </button>
                  </div>
                </div>
              )
            }
            return (
              <div key={item.id} className="card-item">
                <div className="card-container text-center">
                  <div className="card-logo border-gray default-cover">
                    <img
                      loading="lazy"
                      src={
                        item.image
                          ? item.image
                          : cursosimg
                      }
                      alt={"group_" + item.id}
                    />

                  </div>
                  <p className="title">{item.name}</p>
                  <hr></hr>
                  <LinkButton
                    to={`/${rol.current}/group-connect/${item.id}`}
                    className="btn-deg"
                  >
                    Ver
                  </LinkButton>
                </div>
              </div>
            );
          })}
        </div>
      );

      if (step + parseInt(qty) <= data.length) {
        index = step;
        step += parseInt(qty);
      } else {
        index = step;
        step = data.length;
      }
      indice++;
      arrItems.push(carItem);
    }

    setitems([...arrItems]);
    LoadIndicators(indice - 1);
    setloading(false);
  }

  function LoadIndicators(data) {
    let arr = [];

    for (let index = 0; index <= data; index++) {
      let btn = (
        <button
          key={index}
          type="button"
          data-bs-target={"#carousel" + id}
          data-bs-slide-to={index}
          aria-label={"Slide " + (index + 1)}
          className={index === 0 ? "active" : ""}
        ></button>
      );
      arr.push(btn);
    }
    setindicators(arr);
  }

  return (
    <div
      id={"carousel" + id}
      className={loading ? "loader_container" : "carousel slide"}
      data-interval="false"
    >
      {loading ? (
        <Loader type="small"></Loader>
      ) : (
        <Fragment>
          <div className="carousel-inner">{items}</div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target={"#carousel" + id}
            data-bs-slide="prev"
          ></button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target={"#carousel" + id}
            data-bs-slide="next"
          ></button>
        </Fragment>
      )}
    </div>
  );
}

export default CardGroups;
